import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

const { color, font } = baseVariables;

export const StyledRoomsAndEventSpace = styled.div`
  position: relative;
  .hide-cursor {
    caret-color: transparent;
  }
  .dropdown-container {
    position: absolute;
    top: ${toRem(54)};
    width: 100%;
    min-width: ${toRem(348)};
    z-index: 1;
    border-radius: ${toRem(8)};
    background-color: ${color.merch50};
    box-shadow: 0 ${toRem(7)} ${toRem(20)} 0 rgba(0, 0, 0, 0.25);

    .reset-cta {
      background: transparent;
      padding: 0;
      &:focus-visible {
        outline: -webkit-focus-ring-color auto ${toRem(1)};
      }
    }
  }

  .rooms-eventspace-container {
    .stepper-section {
      padding-bottom: ${toRem(8)};
      border-bottom: ${toRem(1)} solid ${baseVariables.color.neutral20};
    }
    .m-stepper-square {
      .decrement-btn,
      .increment-btn {
        button {
          padding: 0;
          margin: 0;
        }
      }
      .counter {
        width: ${toRem(60)};
      }
    }
    .m-stepper-label .m-stepper-desc {
      max-width: ${toRem(150)};
    }

    .stepper-error {
      .counter {
        border: ${toRem(1)} solid ${color.alert50};
      }
    }

    .stepper-error-text {
      color: ${color.alert50};
      font-size: ${toRem(12)};
      font-weight: ${font.fontWeightRegular};
      margin-bottom: ${toRem(4)};
    }
  }

  .mobile-container {
    .m-stepper-wrapper {
      .m-stepper-label {
        .t-font-s {
          font-weight: ${font.fontWeightMedium};
          font-size: ${toRem(16)};
        }
      }
    }
  }
`;
